function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-camera");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-camera",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25,8.5 C25.8284271,8.5 26.5,9.17157288 26.5,10 L26.5,22 C26.5,22.8284271 25.8284271,23.5 25,23.5 L5,23.5 C4.17157288,23.5 3.5,22.8284271 3.5,22 L3.5,10 C3.5,9.17157288 4.17157288,8.5 5,8.5 L25,8.5 Z M15,11.5 C12.5147186,11.5 10.5,13.5147186 10.5,16 C10.5,18.4852814 12.5147186,20.5 15,20.5 C17.4852814,20.5 19.5,18.4852814 19.5,16 C19.5,13.5147186 17.4852814,11.5 15,11.5 Z M23,11 C22.4477153,11 22,11.4477153 22,12 C22,12.5522847 22.4477153,13 23,13 C23.5522847,13 24,12.5522847 24,12 C24,11.4477153 23.5522847,11 23,11 Z M7.2,7.5 L8.8,7.5",
  id: "Combined-Shape"
})));

const SvgIco30Camera = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Camera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-camera.c890b38a.svg";
export { ForwardRef as ReactComponent };